__turbopack_context__.v({
  "header-menu": "QAAMnG_header-menu",
  "header-menu--mobile-expanded": "QAAMnG_header-menu--mobile-expanded",
  "header-menu__active-region": "QAAMnG_header-menu__active-region",
  "header-menu__close": "QAAMnG_header-menu__close",
  "header-menu__footer": "QAAMnG_header-menu__footer",
  "header-menu__footer-actions": "QAAMnG_header-menu__footer-actions",
  "header-menu__footer-links": "QAAMnG_header-menu__footer-links",
  "header-menu__item": "QAAMnG_header-menu__item",
  "header-menu__link": "QAAMnG_header-menu__link",
  "header-menu__list": "QAAMnG_header-menu__list",
  "header-menu__mobile-header": "QAAMnG_header-menu__mobile-header",
  "header-menu__parent": "QAAMnG_header-menu__parent",
  "header-menu__parent--expanded": "QAAMnG_header-menu__parent--expanded",
  "header-menu__parent-wrapper": "QAAMnG_header-menu__parent-wrapper",
  "header-menu__v-bar": "QAAMnG_header-menu__v-bar",
  "header-submenu": "QAAMnG_header-submenu",
  "header-submenu__back": "QAAMnG_header-submenu__back",
  "header-submenu__heading": "QAAMnG_header-submenu__heading",
  "header-submenu__item": "QAAMnG_header-submenu__item",
  "header-submenu__link": "QAAMnG_header-submenu__link",
  "header-submenu__link-inner": "QAAMnG_header-submenu__link-inner",
  "header-submenu__list": "QAAMnG_header-submenu__list",
});
